/* eslint-disable no-undef,func-names */
import { Component } from "react";
import PropTypes from "prop-types";
import { formatDate } from "../../utils/date";
import constants from "../../utils/constants";

function gadaydiff(first, second) {
  return Math.round((second - first) / (1000 * 60 * 60 * 24));
}

class GoogleAnalytics extends Component {
  componentDidMount() {
    window.ga =
      window.ga ||
      function () {
        (ga.q = ga.q || []).push(arguments);
      };
    window.ga.l = +new Date(); // eslint-disable-line

    const { gaCodeNumber, gaDomains, isPropertyAvailable, sendClientData } = this.props;
    let { startDate, endDate } = this.props;
    startDate = formatDate(startDate, "DD-MM-YYYY");
    endDate = formatDate(endDate, "DD-MM-YYYY");
    let dateArr = startDate.split("-");
    const cStartDate = new Date(dateArr[2], parseInt(dateArr[1], 10) - 1, dateArr[0]);
    dateArr = endDate.split("-");
    const cEndtDate = new Date(dateArr[2], parseInt(dateArr[1], 10) - 1, dateArr[0]);
    const gaNights = gadaydiff(cStartDate, cEndtDate);

    // Witbooking side
    const parsedGaDomains = (gaDomains && gaDomains.toJS()) || [];
    parsedGaDomains.push("witbooking.com");
    window.ga("tgaown.set", "dimension1", isPropertyAvailable);
    window.ga("tgaown.set", "dimension2", startDate + "_" + endDate);
    window.ga("tgaown.set", "dimension3", startDate + "_" + gaNights);

    window.wbkGaClientList = [];
    // Client side
    if (gaCodeNumber && gaCodeNumber !== "") {
      const gaCodeNumbers = gaCodeNumber.split(",");
      gaCodeNumbers.forEach((gaCode, idx) => {
        const clientName = `tgaclient${(idx > 0 && idx) || ""}`;
        window.wbkGaClientList.push(clientName);
        window.ga(`${clientName}.set", "dimension1`, isPropertyAvailable);
        window.ga(`${clientName}.set", "dimension2`, startDate + "_" + endDate);
        window.ga(`${clientName}.set", "dimension3`, startDate + "_" + gaNights);
      });
    }

    window.ga(function () {
      if (typeof window.ga.getByName === "function") {
        let tracker = window.ga.getByName("tgaclient");

        if (!tracker) {
          tracker = window.ga.getByName("tgaown");
        }
        window.wbkGaLinker = window.gaplugins ? new window.gaplugins.Linker(tracker) : null;

        let gaClientId;
        let gaReferrer;

        gaClientId = window.ga.getByName("tgaclient").get("clientId");
        if (typeof gaClientId === "undefined") {
          gaClientId = window.ga.getByName("tgaown").get("clientId");
        }

        gaReferrer = window.ga.getByName("tgaclient").get("referrer");
        if (typeof gaReferrer === "undefined") {
          gaReferrer = window.ga.getByName("tgaown").get("referrer");
        }
        sendClientData({
          gaClientId,
          gaReferrer: gaReferrer || document.referrer,
        });
      }
    });

    // Tracking pageView for first load
    window.ga("tgaown.send", "pageview", document.location.pathname + document.location.search);
    window.wbkGaClientList.forEach(gaClientName =>
      window.ga(
        `${gaClientName}.send`,
        "pageview",
        document.location.pathname + document.location.search
      )
    );
  }

  componentWillUpdate(nextProps) {
    if (
      nextProps.currentStep === constants.STEP_PATHS.STEP_3 &&
      nextProps.reservationCreated &&
      nextProps.externalReservation &&
      nextProps.externalReservation.status === constants.RESERVATION_STATUS.CONFIRMED
    ) {
      if (!nextProps.isLoaded) {
        nextProps.loaded();
      }
    }
  }

  render() {
    return null;
  }
}

GoogleAnalytics.propTypes = {
  gaDomains: PropTypes.object,
  currentStep: PropTypes.string,
  reservationCreated: PropTypes.bool,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  isPropertyAvailable: PropTypes.bool,
  gaCodeNumberWitbooking: PropTypes.string,
  gaCodeNumber: PropTypes.string,
  propertyTicker: PropTypes.string,
  defaultCurrency: PropTypes.string,
  sendClientData: PropTypes.func,
  isLoaded: PropTypes.bool,
};

export default GoogleAnalytics;
